<template>
  <v-tabs class="sub-menu" slider-color="primary" height="64" style="margin-bottom: 15px;" background-color="transparent">
    <v-tab
      class="sub-menu-item"
      to="/booking/flight"
      v-if="$store.getters.hasPermission('viewBookingAssigned') || $store.getters.hasPermission('viewAllBookings')"
    >
      <v-icon class="sub-menu-item-icon">flight</v-icon>
      {{ $t("booking.menu.flight") }}
    </v-tab>
    <v-tab
      class="sub-menu-item"
      to="/booking/hotel"
      v-if="
        $store.getters['userProperties'].system_settings.is_module_all_bookings_enabled === 2 &&
          ($store.getters.hasPermission('viewBookingAssigned') || $store.getters.hasPermission('viewAllBookings'))
      "
    >
      <v-icon class="sub-menu-item-icon">hotel</v-icon>
      {{ $t("booking.menu.hotel") }}
    </v-tab>
    <v-tab
      to="/booking/rail"
      class="sub-menu-item"
      v-if="
        $store.getters['userProperties'].system_settings.is_module_all_bookings_enabled === 2 &&
          ($store.getters.hasPermission('viewBookingAssigned') || $store.getters.hasPermission('viewAllBookings'))
      "
    >
      <v-icon class="sub-menu-item-icon">train</v-icon>
      {{ $t("booking.menu.rail") }}
    </v-tab>
    <v-tab
      to="/booking/other"
      class="sub-menu-item"
      v-if="$store.getters.hasPermission('viewBookingAssigned') || $store.getters.hasPermission('viewAllBookings')"
    >
      <v-icon class="sub-menu-item-icon">view_headline</v-icon>
      {{ $t("booking.menu.other") }}
    </v-tab>
    <v-tab
      to="/booking/mapping"
      class="sub-menu-item"
      v-if="
        $store.getters.hasPermission('bookingMapping') &&
          ($store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
            $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2)
      "
    >
      <v-icon class="sub-menu-item-icon">fa-user-tag</v-icon>
      {{ $t("booking.menu.mapping") }}
    </v-tab>
    <v-spacer />
    <v-tab to="/booking/report" class="sub-menu-item" v-if="$store.getters.hasPermission('viewAllBookings')">
      <v-icon class="sub-menu-item-icon">show_chart</v-icon>
      {{ $t("global.menu.reports") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "BookingMenu",
  mounted() {
    this.$store.dispatch("Visual/setMenuBackground");
    this.$store.dispatch("Visual/setFullPageView");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
    this.$store.dispatch("Visual/setCenterPageView");
  },
  computed: {}
};
</script>

<style scoped>
.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}
</style>

<style>
.sub-menu .v-tabs__bar {
  background-color: inherit;
}
</style>
